import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Stack,
  Paper,
  CircularProgress
} from "@mui/material";
import axios from "axios";
import baseURL from "../../config";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import Navbar from "../../Navbar/Navbar";

const SeaServiceProfileForm = ({ initialData = null, onCancelEdit, onProfileSaved }) => {
  const isEditMode = !!initialData;

  const [formData, setFormData] = useState({
    companyName: "",
    address: "",
    mobileNumber: "",
    email: "",
    authorisedSignatoryName: "",
    logo: null,
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        companyName: initialData.companyName || "",
        address: initialData.address || "",
        mobileNumber: initialData.mobileNumber || "",
        email: initialData.email || "",
        authorisedSignatoryName: initialData.authorisedSignatoryName || "",
        logo: null,
        existingLogoUrl: initialData.logo?.filePath || "",
      });
    }
  }, [initialData]);

  // console.log("initialData", initialData)
  const [loading, setLoading] = useState(false); // ✅ Start with false
  const { crewingAgentId } = useParams();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setFormData(prev => ({ ...prev, mobileNumber: `+${value}` }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Only PNG and JPG files are allowed.');
        e.target.value = ''; // Clear the input
        return;
      }
    }

    setFormData(prev => ({ ...prev, logo: e.target.files[0] }));


  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("companyName", formData.companyName);
      data.append("address", formData.address);
      data.append("email", formData.email);
      data.append("mobileNumber", formData.mobileNumber);
      data.append("authorisedSignatoryName", formData.authorisedSignatoryName);
      if (formData.logo) data.append("logo", formData.logo);

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found. Please login.");
        return;
      }

      // const crewingAgentId = id;
      // const res = await axios.post(
      //   `${baseURL}/api/createSeaServiceProfile/${crewingAgentId}`,
      //   data,
      //   {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      const url = isEditMode
        ? `${baseURL}/api/updateSeaServiceProfile/${initialData.crewingAgentId}`
        : `${baseURL}/api/createSeaServiceProfile/${crewingAgentId}`;

      const res = await axios[isEditMode ? "put" : "post"](url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(res.data.message || "Profile created successfully");
      if (onProfileSaved) {
        onProfileSaved();
      }
      setTimeout(() => {
        window.location.reload();
      }, 2000)
      setFormData({
        companyName: "",
        address: "",
        mobileNumber: "",
        authorisedSignatoryName: "",
        logo: null,
      });
      e.target.reset();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Box
        component={Paper}
        elevation={3}
        sx={{
          maxWidth: 500,
          mx: "auto",
          mt: 6,
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography variant="h5" mb={3} fontWeight={600} textAlign="center">
          Create Sea Service Profile
        </Typography>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Stack spacing={2}>
            <TextField
              label="Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
              fullWidth
            />

            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              fullWidth
            />

            <TextField
              label="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              fullWidth
            />

            <PhoneInput
              country={'in'}
              value={formData.mobileNumber.replace('+', '')}
              onChange={handlePhoneChange}
              inputStyle={{ width: "100%" }}
              specialLabel="Mobile Number"
              inputProps={{ required: true }}
            />

            <TextField
              label="Authorized Signatory Full Name"
              name="authorisedSignatoryName"
              value={formData.authorisedSignatoryName}
              onChange={handleChange}
              required
              fullWidth
            />

            <Stack spacing={1}>
              <Button variant="outlined" component="label" fullWidth>
                Upload Logo (png, jpg)
                <input
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>

              {formData.logo && (
                <Typography variant="body2" color="text.secondary">
                  Selected File: <strong>{formData.logo.name}</strong>
                </Typography>
              )}
            </Stack>
            {formData.existingLogoUrl && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Existing Logo: {initialData.logo?.originalName || "No logo uploaded"}</Typography>
              </Box>
            )}

            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              fullWidth
              sx={{ py: 1.5 }}
            >
              {loading ? "Submitting..." : "Create Profile"}
            </Button>
          </Stack>
        </form>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default SeaServiceProfileForm;
